"use strict";

angular.module("core")
.controller("EmailInvoiceBulkActionConfirmationController", function(
    $scope, $attrs, close, PatternService, FormError, EMAIL_MAXLENGTH
) {
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    this.text = $attrs.text;
    this.message = $attrs.message;
    this.selectedInstances = $attrs.selectedInstances;
    this.pattern = PatternService;
    this.submitted = false;

    this.close = function(confirm) {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        if (confirm)
            close.apply(this, arguments);
    };

    this.submit = function() {
        this.submitted = true;
        FormError.focus("formConfirm");
        if ($scope.formConfirm.$valid) {
            $scope.$element.modal("hide");
            $scope.$element.remove();
            close.apply(this, [{
                selectedInstances: this.selectedInstances,
                email: $scope.email
            }]);
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/action-modal/email-invoice-confirmation.modal.js
// module id = 911
// module chunks = 0